module.exports = __webpack_public_path__ + "static/nicholson-logo-1bfaebcc29f0df78b382cde2e41cabde.png";